import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import { SxProps, Theme } from '@mui/material';
import styled from 'styled-components';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from '../../../hooks/useTranslation';

interface InputProps {
  disabled?: boolean;
  fullWidth?: boolean;
  initialValue?: string;
  label?: string;
  name: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  required?: boolean;
  type?: string; // For input type like text, password, email, etc.
  withError?: boolean;
  helperText?: string;
  pattern?: {
    value: RegExp;
    message: string;
  };
  maxLength?: number;
  multiline?: boolean;
  inputProps?: React.InputHTMLAttributes<
    HTMLInputElement | HTMLTextAreaElement
  >;
  onFocus?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  size?: 'small' | 'medium';
  sx?: SxProps<Theme>;
}

// Styled component to customize the TextField input
const StyledTextField = styled(TextField)`
  // & .MuiOutlinedInput-root {
  //   border-radius: 10px !important;  /* Custom border radius */
  //   fieldset {
  //     border-width: 1px !important;  /* Custom border width */
  //     border-color: #B3B3B3 !important;  /* Custom border color */
  //   }

  //   &:hover fieldset {
  //     border-color: #B3B3B3 !important;  /* Border color on hover */
  //   }

  //   &.Mui-focused fieldset {
  //     border-color: #B3B3B3 !important;  /* Border color when focused */
  //   }
  // }
`;

const Input: React.FC<InputProps> = ({
  disabled = false,
  fullWidth = true,
  initialValue = '',
  label = 'Error',
  name,
  onChange,
  placeholder,
  required = false,
  type = 'text',
  withError = false,
  helperText,
  pattern,
  maxLength,
  multiline = false,
  inputProps: externalInputProps,
  size = 'medium',
  ...props
}): JSX.Element => {
  const { register, watch } = useFormContext();
  const [value, setValue] = useState<string>(initialValue);
  const watchedValue = watch(name) ?? '';
  const { t } = useTranslation();

  const defaultHelperText = helperText || t('This is a required field');
  const defaultLabel = label === 'Error' ? t('Error') : label;

  return (
    <>
      <StyledTextField
        disabled={disabled}
        fullWidth={fullWidth}
        label={withError ? defaultLabel : ''}
        placeholder={placeholder}
        type={type}
        size={size}
        value={watchedValue || value}
        variant="outlined" /* Ensures the variant is outlined */
        multiline={multiline}
        inputProps={{ maxLength, ...externalInputProps }}
        {...register(name, {
          required,
          onChange: event => setValue(event.target.value as string),
          pattern,
          maxLength,
        })}
        {...props}
        error={withError}
        helperText={withError ? defaultHelperText : ''}
      />
    </>
  );
};

export default Input;
